module.exports = __webpack_public_path__ + "img/advantage3Blue.28aae71d.png";